import React from 'react';
import SheetMusic from '../interfaces/sheetmusic';

interface RegularFeaturedListProps {
  featuredMusic: SheetMusic[];
}

const RegularFeaturedList: React.FC<RegularFeaturedListProps> = ({ featuredMusic }) => {
  return (
    <div>
      {featuredMusic.map((sheet, index) => (
        sheet.isDivider ? (
          <div
            key={sheet.id}
            className={`flex items-center w-full p-4 bg-zinc-800 rounded-lg min-h-[64px] ${index > 0 ? 'mt-12' : 'mt-2'}`}
          >
            <span className="text-white  font-bold text-base">
              {sheet.title}
            </span>
          </div>
        ) : (
          <a
            key={sheet.id}
            href={sheet.downloadURL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center w-full p-4 bg-white border border-zinc-200 rounded-lg hover:bg-zinc-50 hover:border-zinc-300 transition-colors duration-200 text-left no-underline min-h-[64px] mt-2"
          >
            <span className="text-zinc-800  font-medium">
              <strong>{sheet.title}</strong>, <span className="text-zinc-600">{sheet.author}</span>
            </span>
          </a>
        )
      ))}
    </div>
  );
};

export default RegularFeaturedList;